import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { routes } from '@app/app-routing.module';
import { PipesModule } from '@app/presentation/pipes/pipes.module';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ENV, TELEMETRY_CONFIG } from '@environments/environment';
import { ApiInterceptor } from '@services/api/api.interceptor.service';
import { ErrorSectionsInterceptor } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';
import { PtrabSessionInterceptor } from '@services/interceptors/ptrab-session-interceptor/ptrab-session-interceptor.service';
import { CookieService } from 'ngx-cookie-service';
import { provideLottieOptions } from 'ngx-lottie';
import { provideUiTour } from 'ngx-ui-tour-md-menu';

import { getRepositoriesProviders } from '@/di/repositories/repositories-providers';
import { getUseCasesProviders } from '@/di/use-cases/use-cases-providers';

import { MSnackbarService } from '@mercadona/components-musi/snackbar';
import { MLoggerModule } from '@mercadona/core/logger';
import { MPlatformEnvironment, provideMPlatform } from '@mercadona/core/platform';
import { MStorageModule } from '@mercadona/core/storage';
import { provideMTelemetry } from '@mercadona/core/telemetry';
import { MTranslatePipe, provideMTranslate } from '@mercadona/core/translate';
import { provideMIconRegistryPath, URL_BUCKET_MUSI } from '@mercadona/icons';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      AngularFireModule.initializeApp({
        ...ENV.firebaseConfig
      }),
      AngularFireAnalyticsModule,
      PickerModule,
      PipesModule,
      FormsModule,
      ReactiveFormsModule,
      MLoggerModule.forRoot({
        logLevel: ENV.logLevel
      }),
      MStorageModule.forRoot(),
      MTranslatePipe
    ),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideUiTour(),
    provideMTelemetry(TELEMETRY_CONFIG),
    provideMTranslate({ availableLanguages: ['es', 'pt'], defaultLanguage: 'es' }),
    provideMPlatform({
      appName: 'activo2-front-webapp',
      environment: ENV.name as MPlatformEnvironment
    }),
    getUseCasesProviders(),
    getRepositoriesProviders(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorSectionsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PtrabSessionInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es' },
    DatePipe,
    CookieService,
    MSnackbarService,
    provideMIconRegistryPath(URL_BUCKET_MUSI),
    provideHttpClient(withInterceptorsFromDi()),
    provideLottieOptions({
      player: () => import('lottie-web')
    }),
    provideZoneChangeDetection({ eventCoalescing: true })
  ]
};
